<div class="otp-verification-dialog" mat-dialog-content>
  <div class="dialog-header">
    <div class="dialog-title-custom">
      {{ "APP.AUTH.OTP_VERIFICATION.TITLE" | translate }}
    </div>
    <div class="close-button-custom">
      <i class="far fa-times icon-regular" (click)="close()"></i>
    </div>
  </div>

  <div class="dialog-body">
    <div class="dialog-message">
      {{
        "APP.AUTH.OTP_VERIFICATION.EMAIL_MESSAGE" | translate: { email: email }
      }}
    </div>
    <form class="form code-input-form">
      <app-code-input
        #codeInput
        class="code-input"
        [codeLength]="6"
        [hasError]="isWrongCode"
        (codeChanged)="onCodeChanged($event)"
        (codeCompleted)="onCodeCompleted($event)"
      >
      </app-code-input>

      @if (isWrongCode) {
        <div>
          @if (resendSuccess) {
            <div class="text-success">
              {{ "APP.AUTH.SUCCESS.MAIL_RESENT" | translate }}
            </div>
          } @else {
            <mat-error>
              {{ "APP.AUTH.ERRORS.WRONG_CODE" | translate }}
            </mat-error>
          }
        </div>
      }
      @if (isResendInCooldown) {
        <div class="resend-code-cooldown-info">
          {{ "APP.AUTH.OTP_VERIFICATION.RESEND_CODE_WAIT_1" | translate }}
          {{ timeLeft | countdownFormat }}
          {{ "APP.AUTH.OTP_VERIFICATION.RESEND_CODE_WAIT_2" | translate }}
        </div>
      } @else {
        <button
          type="button"
          class="btn btn-sm btn-primary-text"
          (click)="resendEmail()"
          [disabled]="resendInProgress || isResendInCooldown"
        >
          {{ "APP.AUTH.OTP_VERIFICATION.RESEND_CODE" | translate }}
        </button>
      }
      <button
        type="button"
        class="btn btn-sm btn-primary-text"
        (click)="change()"
      >
        {{ "APP.AUTH.OTP_VERIFICATION.CHANGE_EMAIL" | translate }}
      </button>
    </form>
  </div>
</div>
